import {IThreadWorker, TransferListItem} from "@cm/web-assembly"
import {type IWorkerLike} from "@cm/browser-utils"
import {fromEvent as observableFromEvent, Observable} from "rxjs"

export class WebWorker implements IThreadWorker {
    private readonly _onTerminateHooks: (() => void)[] = []

    constructor(private _workerImpl: IWorkerLike) {}

    postMessage(message: unknown, transfer?: TransferListItem[]): void {
        this._workerImpl.postMessage(message, transfer ?? [])
    }

    terminate(): void {
        this._workerImpl.terminate()
        for (const hook of this._onTerminateHooks) {
            hook()
        }
    }

    addOnTerminate(hook: () => void): void {
        this._onTerminateHooks.push(hook)
    }

    observableFromEvent(event: string): Observable<MessageEvent> {
        // Cast needed because IWorkerLike's addEventListener signature uses
        // EventListenerOrEventListenerObject rather than the narrower generic form
        // that RxJS fromEvent's overloads expect.
        return observableFromEvent<MessageEvent>(this._workerImpl as unknown as EventTarget, event)
    }
}
